import CategoryPageLayout from "@/components/CategoryPageLayout";
import ferro1 from "@/assets/ferro-1.jpg";
import ferro2 from "@/assets/ferro-2.jpg";
import ferro3 from "@/assets/ferro-3.jpg";
import ferro4 from "@/assets/ferro-4.jpg";
import ferro5 from "@/assets/ferro-5.jpg";
import ferro6 from "@/assets/ferro-6.jpg";

const subcategories = [
  { image: ferro1, title: "Cancelli", description: "Ingressi sicuri con design personalizzato", slug: "cancelli" },
  { image: ferro2, title: "Ringhiere e balconi", description: "Protezione e stile per ogni balconata", slug: "ringhiere" },
  { image: ferro3, title: "Grate di sicurezza", description: "Inferriate robuste, linee moderne", slug: "grate" },
  { image: ferro4, title: "Scale", description: "Strutture resistenti con finiture curate", slug: "scale" },
  { image: ferro5, title: "Recinzioni", description: "Delimitazione proprietà con eleganza", slug: "recinzioni" },
  { image: ferro6, title: "Balconate", description: "Dettagli in ferro battuto di pregio", slug: "balconate" },
];

const FerroPage = () => (
  <CategoryPageLayout
    heading="Ferro & Sicurezza"
    subtitle="Carpenteria su misura per protezione e accessi. Grate, cancelli, ringhiere, scale: robustezza e design."
    basePath="/ferro"
    subcategories={subcategories}
  />
);

export default FerroPage;
